/* eslint-disable react/prop-types */
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { Button } from 'reactstrap';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

export const AdvanceTablePagination = ({
  canPreviousPage,
  canNextPage,
  previousPage,
  nextPage,
  pageCount,
  pageIndex,
  gotoPage,
  rowsPerPageSelection,
  setPageSize,
  pageSize,
  rowsPerPageOptions,
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pageIndex]);
  const rowsPerPageData = rowsPerPageOptions
    ? rowsPerPageOptions
    : [
        { value: 15, label: '15 rows' },
        { value: 30, label: '30 rows' },
      ];
  return (
    <div className='d-flex align-items-center justify-content-center'>
      {rowsPerPageSelection && pageSize ? (
        <Select
          value={pageSize}
          name='rowsPerPage'
          id='rowsPerPage'
          onChange={(e) => {
            if (setPageSize) {
              setPageSize(e.target.value);
            }
          }}
          className={
            'd-flex align-items-center justify-content-center mr-3 px-2'
          }
          style={{
            height: 56,
            backgroundColor: 'transparent',
            fontSize: '1rem',
            fontFamily: 'Brown Bold',
            color: '#2E2B2B',
            border: 0,
          }}
        >
          {rowsPerPageData.map((opt, index) => {
            return <MenuItem value={opt.value}>{opt.label}</MenuItem>;
          })}
        </Select>
      ) : null}
      {canPreviousPage ? (
        <Button
          size='sm'
          onClick={() => previousPage()}
          className={'d-flex align-items-center justify-content-center'}
          style={{
            height: 56,
            width: 56,
            borderTopLeftRadius: 30,
            borderBottomLeftRadius: 30,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            backgroundColor: 'transparent',
            fontSize: 14,
            borderColor: '#2E2B2B',
            borderWidth: 1,
            fontFamily: 'Brown Bold',
            color: '#2E2B2B',
          }}
        >
          <ArrowBackIcon />
        </Button>
      ) : null}
      <ul className='pagination mb-0'>
        {Array.from(Array(pageCount).keys()).map((page, index, array) => (
          <li key={page}>
            <Button
              size='sm'
              onClick={() => gotoPage(page)}
              style={{
                height: 56,
                width: 56,
                borderTopLeftRadius: page+1 === 1 && !canPreviousPage ? 30 : 0 ,
                borderBottomLeftRadius: page+1 === 1 && !canPreviousPage ? 30 : 0,
                borderTopRightRadius: page+1 === array.length && !canNextPage ? 30 : 0,
                borderBottomRightRadius: page+1 === array.length && !canNextPage ? 30 : 0,
                backgroundColor: pageIndex === page ? '#F9E4D7' : 'transparent',
                borderColor: pageIndex === page ? '#2E2B2B' : '#2E2B2B',
                borderWidth: 1,
                borderRightWidth: page+1 === array.length && !canNextPage ? 1 : 0,
                borderLeftWidth: page+1 === 1 && canPreviousPage ? 0 : 1,
                fontSize: 14,
                fontFamily: 'Brown Bold',
                color: '#2E2B2B',
              }}
            >
              {page + 1}
            </Button>
          </li>
        ))}
      </ul>
      {canNextPage ? (
        <Button
          size='sm'
          onClick={() => nextPage()}
          className={'d-flex align-items-center justify-content-center'}
          style={{
            height: 56,
            width: 56,
            borderTopRightRadius: 30,
            borderBottomRightRadius: 30,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            backgroundColor: 'transparent',
            fontSize: 14,
            borderColor: '#2E2B2B',
            borderWidth: 1,
            fontFamily: 'Brown Bold',
            color: '#2E2B2B',
          }}
        >
          <ArrowForwardIcon />
        </Button>
      ) : null}
    </div>
  );
};

export default AdvanceTablePagination;
